import { neutral, brand } from '../global';
export const background = {
    primary: neutral[100],
    secondary: neutral[97],
    inverse: neutral[10],
    ctaPrimary: brand[400],
    ctaPrimaryHover: '#234B8A',
    ctaSecondary: brand[800],
    ctaSecondaryHover: '#ACC9F7',
    ctaTertiaryHover: '#E5E5E5',
    input: neutral[100],
    inputChecked: brand[500],
};
//# sourceMappingURL=default.js.map
